if(!customElements.get('collection-slideshow')) {
    customElements.define('collection-slideshow', class CollectionSlideshow extends HTMLElement {
        constructor() {
            super();

            let initialAutoTransition = this.getAttribute("auto-transition");
            initialAutoTransition == "false" ? this.autoTransition = false : this.autoTransition = true
            this.transitionDuration = this.getAttribute("transition-duration")
            this.animationDuration = this.getAttribute("animation-duration")
            this.numberOfSlides = this.getElementsByClassName("slide").length;

            this.querySelectorAll('button[name="previous"]').forEach((button) => {
                button.addEventListener('click', () => this.onButtonClick(this, -1, true));
            })

            this.querySelectorAll('button[name="next"]').forEach((button) => {
                button.addEventListener('click', () => this.onButtonClick(this, 1, true));
            })

            this.setMobileDescriptionHeight();
            const resizeObserver = new ResizeObserver(entries => this.setMobileDescriptionHeight());
            
            resizeObserver.observe(this.getElementsByClassName('slideshow-inner')[0]);

            //Autoplay
            if(this.autoTransition && this.numberOfSlides > 1){
                clearInterval(this.interval)
                this.interval = setInterval(() => this.onButtonClick(this, 1), this.transitionDuration);   
            } 

            //indexes
            this.setSlideTabIndex();
        }

        onButtonClick(e, number, clicked = false){
            let currentSlide = this.querySelector(".show-slide")
            currentSlide.classList.add("hide-slide")
            currentSlide.classList.remove("show-slide") 
            var currentIndex = parseInt(currentSlide.dataset.index)
            currentIndex = currentIndex + number;

            if(currentIndex > this.numberOfSlides){
                currentIndex = 1;
            }
        
            if(currentIndex < 1){
                currentIndex = this.numberOfSlides
            } 
            
            let nextslide = this.getElementsByClassName(`slide-index-${currentIndex}`)[0]
            
            setTimeout(() => {
                currentSlide.classList.add("absolute-slide");
                nextslide.classList.remove("absolute-slide");
            }, this.animationDuration)
        
            nextslide.classList.remove("hide-slide")  
            nextslide.classList.add("show-slide")

            if(clicked && this.autoTransition){
                clearInterval(this.interval)
                this.interval = setInterval(() => this.onButtonClick(this, 1), this.transitionDuration);
            }

            this.setSlideTabIndex();
        }

        //Set slide tabindex
        setSlideTabIndex(){
            this.querySelectorAll(".slide").forEach(slide => {
                const buttons = slide.querySelectorAll('a, button');
                if(slide.classList.contains("show-slide")){
                    buttons.forEach(button => {
                        button.setAttribute('aria-hidden', 'false');
                        button.removeAttribute('tabindex');
                    })            
                }else{
                    buttons.forEach(button => {
                        button.setAttribute('aria-hidden', 'true');
                        button.setAttribute('tabindex', '-1');
                    })
                }     
            })
        }

        //This prevents content jumps on transitions
        setMobileDescriptionHeight(){
            let containerHeight;
            this.querySelectorAll('.slideshow-product-description-outer').forEach((container) => {
                container.style.height = '100%';
                if(window.matchMedia("(max-width: 991px)").matches){
                    containerHeight >= container.offsetHeight ? containerHeight = containerHeight : containerHeight = container.offsetHeight;
                }else{
                    containerHeight = 'auto'
                }            
            })

            this.querySelectorAll('.slideshow-product-description-outer').forEach((container) => {
                container.style.height = `${containerHeight}px`
            })
        }
        
        pause(selectedSlide) {
            let index = selectedSlide.dataset.index - this.querySelector(".show-slide").dataset.index;
            this.onButtonClick(this, index)
            clearInterval(this.interval)
        }

        play() {
            clearInterval(this.interval);
            if(this.autoTransition){
                this.onButtonClick(this, 0, true)
            }
        }
    })
}